function flattenStyle(style) {
  if (!style) {
    return void 0;
  }
  if (!Array.isArray(style)) {
    return style;
  }
  var result;
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = style[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;
      var flat = flattenStyle(item);
      if (flat) {
        result = {
          ...result,
          ...flat
        };
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return result;
}
function convertFontWeightToStringFontWeight(fontWeight) {
  if (fontWeight === void 0) {
    return void 0;
  }
  if (typeof fontWeight === "number") {
    return String(fontWeight);
  }
  return fontWeight;
}
export {
  convertFontWeightToStringFontWeight,
  flattenStyle
};
//# sourceMappingURL=style.js.map
